import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Connect from "../../redux/Connect.hoc";
import { TiWorld } from 'react-icons/ti'
import { AiOutlineMail } from 'react-icons/ai'
import { FiPhoneCall } from 'react-icons/fi'
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa'

// import logo from '../../media/logo.png'
import logo from '../../media/footer-logo.png'
import "./styles.scss";

const FooterBar = () => {
  const sizeIcons = '2.5rem';
  
  //Metodos
  useEffect(() => {
    console.log(" --FooterBar.useEffect-- ");
  }, []);

  return (
    <footer className="Footer">

    <div className="Footer-Div">
      <div className="Footer-Div-list">
          <div>
          <TiWorld  size={sizeIcons} />
          </div>
              <p>Servicio 24/7</p>
              <p>365 días del año</p>
        </div>
        <div className="Footer-Div-list">
          <div>
          <img src={logo} alt="logo"/>
          </div>
          <div>
          <AiOutlineMail size={sizeIcons}/>
          </div>
              <p>info@todoak.co</p>
              <p>Email</p>
            <p>
        © 2020 :
        <a > TodoAk - Todos los derechos reservados</a>
            </p>
        </div>
        <div className="Footer-Div-list">
        <div>
        <FiPhoneCall size={sizeIcons}/>
        </div>
              <p>+57 313 605 0921</p>
              <p>WhatsApp</p>

        </div>

    </div>
    <div className="Footer-icons">

          <FaFacebook className='icon-footer' />
            <FaInstagram className='icon-footer' />
            <FaLinkedin className='icon-footer' />

    </div>
          </footer>
  )

};
export default Connect(withRouter(FooterBar));
